import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '@barthauer/abc/core/authentication';
import { AppService } from '../services/app.service';
import { TicketDetailComponent } from './ticket-detail/ticket-detail.component';
import { TicketListComponent } from './ticket-list/ticket-list.component';

const ticketsRoutes: Routes = [
  {
    path: 'TicketList',
    component: TicketListComponent,
    data: { animation: 'TicketList', reuse: true, mainOutletName: 'mainOutlet' },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Tickets,
  },
  {
    path: 'TicketDetail',
    component: TicketDetailComponent,
    data: { animation: 'TicketDetail', mainOutletName: 'mainOutlet' },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Tickets,
  },
];

@NgModule({
  imports: [RouterModule.forChild(ticketsRoutes)],
  exports: [RouterModule],
})
export class TicketsRoutingModule {}
